module.exports = __webpack_public_path__ + "static/logo-dark-bcaa886e7ccab4e66f6ce895a0f13167.svg";